export default {"src":"/kaimono/_next/static/media/wamazing_discover_h.cc08cad9.svg","height":117,"width":482};